import { useAuth } from "@/hooks/use-auth";
import { Redirect } from "wouter";
import AppShell from "@/components/layout/AppShell";
import EmailConnectionForm from "@/components/emails/EmailConnectionForm";

export default function EmailSettings() {
  const { user } = useAuth();

  if (!user) {
    return <Redirect to="/auth/login" />;
  }

  return (
    <AppShell>
      <div className="p-6 space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold">Email Settings</h1>
            <p className="text-muted-foreground">
              Configure your email connection for player data extraction
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6">
          <EmailConnectionForm />
        </div>
      </div>
    </AppShell>
  );
}